import React, { useContext, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { mobile } from "../../utilities/detection";
import { AdContext } from "../../context/adContext";
import { useAdCount, useWidthSize } from "../../hooks";
import { adData } from "../../config/constants";
import { adsSelector } from "../../redux/slices/loginSlice";
import { getString } from "../../utilities";

export default function Sky160600({ isLeft = false }) {
  const adDiv = useRef(null);
  const skyShow = useWidthSize(["adsLG", "xl", "xxl"]);
  const { skyLeftDiv, skyRightDiv, skyLeftCreated, skyRightCreated } = useContext(AdContext);
  const ads = useSelector(adsSelector);

  const adId = isLeft ? adData.divIds.sky.left : adData.divIds.sky.right;
  const doShow = !mobile && skyShow;
  useAdCount(adId, adDiv, doShow);

  const handleAdDiv = useCallback((node) => {
    if (node) {
      adDiv.current = isLeft ? skyLeftDiv : skyRightDiv;
      node.appendChild(isLeft ? skyLeftDiv : skyRightDiv);
      if (isLeft) {
        if (!skyLeftCreated.current) skyLeftCreated.current = true;
      } else {
        if (!skyRightCreated.current) skyRightCreated.current = true;
      }
    }
  }, []);

  if (ads && doShow) {
    // only shown if screen is wider than "adsLg(1180px)"
    //  see config breakpoints

    return (
      <div data-testid="sky-ad" className="a-skyscraper">
        <div id={`${adId}-container`} className="a-skyscraper-container" ref={handleAdDiv} />
        <div className="a-cta">{getString("ads.ad")}</div>
      </div>
    );
  }

  return null;
}
